<div class="deal-preview-container" [ngClass]="isStandalonePage ? 'standalone' : 'platform'">

    <!-- static section  -->
    <div>
        <mat-toolbar id="toolbar-nav" class="mat-primary space-between" *ngIf="!!theme && isStandalonePage"
                    [ngStyle]="{'background-color': theme.header_bg,color: theme.header_fg}">
            <img src="assets/images/Rondeivu-white-logo.png" style="height: 46px;">

            <button mat-button  
                title="Go to your Rondeivu Dashboard"
                *ngIf="userIsLoggedIn" (click)="goToDashboard()">
                <mat-icon>dashboard</mat-icon>
            </button>
        </mat-toolbar>

        <div class="page-padding">
            <div class="space-between">
                <span>
                    <span class="rm-title rm-title-3" *ngIf="deal">{{deal.projectName}} - Pre-NDA Preview</span><br/>
                    <span class="rm-title rm-title-6 rm-lighter">You can view this deal in a pre-NDA format, if you are interested in being matched to this deal please express your interest</span>
                </span>
                <span>
                    <button mat-raised-button *ngIf="isStandalonePage == true" (click)="requestMoreInformation()" color="primary">Access Full Details</button>
                    <button mat-raised-button *ngIf="isStandalonePage == false" (click)="requestDealMatch()" color="primary">Request a Deal Match</button>
                </span>
            </div>
        </div>
    </div>

    <div class="feature-container page-padding" *ngIf="deal">

        <div class="image-container preview-image-container">
            <img class="preview-image" [src]="deal.dealImageUrl" alt="Deal Image"/>
        </div>
        <div class="text-container" style="display: flex; flex-direction: column; gap: 45px;">
            <div class="preview-content">
                <span class="section-header">
                    <h3>Multiple on Invested Capital (MOIC)</h3>
                    <em class="text-muted">Return metrics modelled by the GP</em>
                </span>

                <div class="metrics-container">
                    <div class="metric">
                        <span class="metric-label">Bear Case</span>
                        <span class="metric-value">{{deal.targetMoicBear}} x</span>
                    </div>
                    <div class="metric">
                        <span class="metric-label">Base Case</span>
                        <span class="metric-value">{{deal.targetMoicBase}} x</span>
                    </div>
                    <div class="metric">
                        <span class="metric-label">Best Case</span>
                        <span class="metric-value">{{deal.targetMoicBest}} x</span>
                    </div>
                </div>
            </div>
            <div class="preview-content">
                <span class="section-header">
                    <h3>Duration</h3>
                    <em class="text-muted">Timelines modelled by the GP</em>
                </span>
                <div class="metrics-container">
                    <div class="metric">
                        <span class="metric-label">Min Duration</span>
                        <span class="metric-value">{{deal.minimumDuration}} years</span>
                    </div>
                    <div class="metric">
                        <span class="metric-label">Expected Duration</span>
                        <span class="metric-value">{{deal.expectedDuration}} years</span>
                    </div>
                    <div class="metric">
                        <span class="metric-label">Max Duration</span>
                        <span class="metric-value">{{deal.maximumDuration}} years</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="page-padding" style="display: flex; flex-direction: column; gap: 45px;" *ngIf="deal">
        <!-- info section-->
        <div class="info-section">
            <table class="info-table" id="info-table" width="100%">
                <tr class="info-row">
                    <td class="info-title-cell">Asset Class</td>
                    <td class="info-data-cell">
                        <span *ngFor="let a of deal.assetClasses" class="chip">{{ a }}</span>
                    </td>
                </tr>
                <tr class="info-row">
                    <td class="info-title-cell">Deal Type</td>
                    <td class="info-data-cell">
                        <span *ngFor="let a of deal.dealTypes" class="chip">{{ a }}</span>
                    </td>
                </tr>
                <tr class="info-row">
                    <td class="info-title-cell">Total Fundraise Size</td>
                    <td class="info-data-cell-padded">{{ deal.fundraiseSize | currency: 'USD' : 'symbol' : '2.0' }} Million USD</td>
                </tr>
                <tr class="info-row">
                    <td class="info-title-cell">Close Date</td>
                    <td class="info-data-cell-padded">{{ deal.closeDate | date }}</td>
                </tr>
                <tr class="info-row">
                    <td class="info-title-cell">Deal Close Type</td>
                    <td class="info-data-cell-padded">{{ deal.dealCloseType }}</td>
                </tr>
                <tr class="info-row">
                    <td class="info-title-cell" colspan="2">Transaction Description</td>
                </tr>
                <tr>
                    <td colspan="2" class="p-2">
                        <span class="p-1" [innerHTML]="deal.description"></span>
                    </td>
                </tr>
            </table>
        </div>


        <!-- Dataroom -->
        <div class="preview-dataroom full-width" *ngIf="this.dataSource.data.length > 0">
            <span class="section-header">
                <h3>Deal Dataroom</h3>
                <em class="muted-text">The deal includes a more comprehensive dataroom, available after the NDA is signed.</em>
            </span>

            <table class="dataroom-table" mat-table [dataSource]="dataSource" >
                <ng-container matColumnDef="documentName">
                    <mat-header-cell *matHeaderCellDef class="dataroom-header-cell document-name-cell">Document Name</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="dataroom-cell document-name-cell">{{element.documentName}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="fileType">
                    <mat-header-cell *matHeaderCellDef class="dataroom-header-cell file-type-cell">File Type</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="dataroom-cell file-type-cell">{{element.fileType}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="size">
                    <mat-header-cell *matHeaderCellDef class="dataroom-header-cell file-type-cell">Size</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="dataroom-cell file-type-cell">{{element.size | fileSize : 0}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="created">
                    <mat-header-cell *matHeaderCellDef class="dataroom-header-cell file-date-cell">Created</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="dataroom-cell file-date-cell">
                        <div class="date-stacked">
                        <span>{{ element.created | date : 'mediumDate' }}</span>
                        <span>{{ element.created | date : 'shortTime' }}</span>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef class="dataroom-header-cell file-actions-cell">Actions</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="dataroom-cell file-actions-cell">
                        <button mat-icon-button color="primary" title="Download Document" (click)="downloadDocument(element)">
                            <mat-icon>cloud_download</mat-icon>
                        </button>
                        <!-- <button mat-icon-button color="primary" title="Open Document" (click)="downloadDocument(element)">
                            <mat-icon>open_in_new</mat-icon>
                        </button> -->
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="documentName"></mat-header-row>
                <mat-row *matRowDef="let row; columns: documentName;"></mat-row>
            </table>
        </div>

        <!-- more information -->
        <div class="row text-center mt-5 mb-5">
            <span>
                <button mat-raised-button *ngIf="isStandalonePage == true" (click)="requestMoreInformation()" color="primary">Access Full Details</button>
                <button mat-raised-button *ngIf="isStandalonePage == false" (click)="requestDealMatch()" color="primary">Request a Deal Match</button>
            </span>
        </div>
   </div>

   
    <footer>
        For informational purposes only. Does not constitute an offer to sell or solicitation to buy securities. Restricted to Institutional Investors (US) and Permitted Clients (Canada). Not for distribution where prohibited by law. Private market investments are illiquid and may result in total loss of capital.
    </footer>
</div>
